import { Injectable, inject } from '@angular/core';
import { CompanyApiService } from '@api-new/companyservice';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { UserInactivityService } from '@shared/services/user-inactivity.service';
import { getClientUserSuccess } from '@shared/store/client-user/client-user.actions';
import { of } from 'rxjs/internal/observable/of';
import { catchError, map, switchMap } from 'rxjs/operators';
import { getCompanyById, getCompanyByIdFailure, getCompanyByIdSuccess } from './company.actions';

@Injectable()
export class CompanyEffects {
  private readonly userInactivityService = inject(UserInactivityService);
  private readonly companyApiService = inject(CompanyApiService);
  private readonly actions$ = inject(Actions);

  handleGetClientUserSuccess = createEffect(() =>
    this.actions$.pipe(
      ofType(getClientUserSuccess),
      map(({ clientUser }) => getCompanyById({ id: clientUser.companyId })),
    ),
  );

  getCompanyById = createEffect(() =>
    this.actions$.pipe(
      ofType(getCompanyById),
      switchMap(({ id }) => this.companyApiService.HTTP_CP_GetCompany({ companyId: id })),
      map((company) => {
        if (company.companyClientUISettings?.inactivityTimeoutInMinutes)
          this.userInactivityService.startMonitoring(
            company.companyClientUISettings.inactivityTimeoutInMinutes,
            company.companyClientUISettings.inactivityTimeoutRedirectUrl,
          );
        return getCompanyByIdSuccess({ company });
      }),
      catchError((error) => of(getCompanyByIdFailure({ error }))),
    ),
  );
}
